import { MenuSystemUpdateItem } from "../model/menu-system-update-item";

export class MenuSystemUpdates {
    static menuSystemItems: MenuSystemUpdateItem[];
}